<template>
  <v-main style="padding: 0px">
    <ActitiveTabcomponent
      :tabs="teamReviewContext.visibleTabs"
      :default-tab="teamReviewContext.activeTab"
      :inside-dialog="false"
      @tab-changed="teamReviewContext.handleTabChange"
    >
      <!-- Mobile Tab Buttons Slot -->
      <template v-slot:tab-buttons="{ activeTab }">
        <div class="flex items-center gap-1.5 py-1">
          <!-- Daily Filter Date Picker (Only on Map/Timeline tabs) -->
          <div v-if="activeTab === 'map' || activeTab === 'timeline'" class="flex items-center">
            <v-menu
              v-model="teamReviewContext.employeeDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  outlined
                  class="normal-case font-semibold px-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left size="14">mdi-calendar</v-icon>
                  {{ $dayjs(teamReviewContext.selectedDate).format('DD MMM') }}
                </v-btn>
              </template>
              <v-date-picker
                v-model="teamReviewContext.selectedDate"
                @input="
                  teamReviewContext.employeeDateMenu = false
                  teamReviewContext.onDateSelected()
                "
                :max="$dayjs().format('YYYY-MM-DD')"
                scrollable
                no-title
              ></v-date-picker>
            </v-menu>
          </div>

          <!-- Export Actions -->
          <div v-if="activeTab !== 'calendar'" class="flex items-center">
            <!-- Map Export -->
            <v-btn
              v-if="activeTab === 'map'"
              :loading="teamReviewContext.exportLoading"
              v-iam-disabled="'team_review.map.export'"
              :color="$vuetify.theme.currentTheme.primary"
              class="white--text normal-case text-xs px-2"
              small
              depressed
              @click="teamReviewContext.exportMapData"
              v-show="teamReviewContext.isExportButtonVisible"
            >
              <v-icon left size="14">mdi-download</v-icon>
              Export
            </v-btn>

            <!-- Other Tabs Export -->
            <v-menu
              v-else
              offset-y
              v-iam-disabled="activeTab === 'attendance' ? 'team_review.attendance.export' : 'team_review.roster.export'"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  :loading="teamReviewContext.exportLoading"
                  v-iam-disabled="activeTab === 'attendance' ? 'team_review.attendance.export' : 'team_review.roster.export'"
                  :color="$vuetify.theme.currentTheme.primary"
                  class="white--text normal-case text-xs px-2"
                  small
                  depressed
                  v-on="on"
                  v-show="teamReviewContext.isExportButtonVisible"
                >
                  <v-icon left size="14">mdi-download</v-icon>
                  Export
                </v-btn>
              </template>
              <v-list v-if="teamReviewContext.roasterTab" v-show="teamReviewContext.isFeatureVisible('DOWNLOAD_ROSTER')">
                <v-list-item class="text-xs" @click="teamReviewContext.exportShiftData"
                  >Download Shift Data</v-list-item
                >
              </v-list>
              <v-list v-else v-show="teamReviewContext.isFeatureVisible('DOWNLOAD_REPORT')">
                <v-list-item class="text-xs" @click="teamReviewContext.downloadCheckInUsers"
                  >Attendance Report</v-list-item
                >
                <v-list-item class="text-xs" @click="teamReviewContext.downloadMusterReport3"
                  >Muster Report</v-list-item
                >
                <v-list-item class="text-xs" @click="teamReviewContext.exportTaskData"
                  >Download Tasks Data</v-list-item
                >
              </v-list>
            </v-menu>
          </div>

          <!-- Mobile Filter PopOver -->
          <FilterPopOver v-if="activeTab !== 'map'" :selectedCount="teamReviewContext.selectedCount">
            <v-card outlined class="pa-3 w-64 max-h-[70vh] overflow-y-auto flex flex-col gap-3">
              <div v-if="teamReviewContext.tabs === 2" class="flex items-center justify-between">
                <span class="text-xs font-semibold text-gray-700">Graphical View</span>
                <v-switch
                  dense
                  hide-details
                  v-model="teamReviewContext.graphicalView"
                  class="mt-0 pt-0"
                ></v-switch>
              </div>

              <!-- Employee Search Box -->
              <div>
                <label class="text-[10px] uppercase font-bold text-gray-400 block mb-1">Search Employee</label>
                <v-text-field
                  v-model="teamReviewContext.employeeSearch"
                  outlined
                  dense
                  hide-details
                  placeholder="Employee Name"
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  @input="teamReviewContext.handleInput"
                ></v-text-field>
              </div>

              <!-- Employee Status Selector -->
              <div>
                <label class="text-[10px] uppercase font-bold text-gray-400 block mb-1">Status</label>
                <v-select
                  v-model="teamReviewContext.employeeStatus"
                  :items="['ACTIVE', 'INACTIVE']"
                  outlined
                  dense
                  hide-details
                  @change="teamReviewContext.handleInput"
                ></v-select>
              </div>

              <!-- Task Status Selector (Only if tabs === 2) -->
              <div v-if="!teamReviewContext.graphicalView && teamReviewContext.tabs === 2">
                <label class="text-[10px] uppercase font-bold text-gray-400 block mb-1">Task Status</label>
                <v-select
                  v-model="teamReviewContext.selectedTaskStatus"
                  :items="teamReviewContext.taskSteps"
                  item-text="value"
                  item-value="key"
                  hide-details
                  multiple
                  small-chips
                  clearable
                  outlined
                  dense
                ></v-select>
              </div>

              <!-- Date Range Type Selector -->
              <div>
                <label class="text-[10px] uppercase font-bold text-gray-400 block mb-1">Date Range Type</label>
                <v-select
                  v-model="teamReviewContext.dateRangeType"
                  :items="teamReviewContext.dateRangeTypes"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </div>

              <!-- Date Picker Menu -->
              <div>
                <label class="text-[10px] uppercase font-bold text-gray-400 block mb-1">Select Date Range</label>
                <v-menu
                  v-model="teamReviewContext.menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="teamReviewContext.formattedMonth"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      hide-details
                      outlined
                      dense
                      clearable
                      @click:clear="teamReviewContext.onDateCleared"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-if="teamReviewContext.dateRangeType === 'Monthly'"
                    v-model="teamReviewContext.selectedDate"
                    @input="
                      teamReviewContext.menu = false
                      teamReviewContext.onDateSelected()
                    "
                    :min="teamReviewContext.minDate"
                    :max="teamReviewContext.maxDate"
                    type="month"
                    scrollable
                  />
                  <v-date-picker
                    v-show="teamReviewContext.dateRangeType === 'Custom Date' || teamReviewContext.dateRangeType === 'custom'"
                    v-model="teamReviewContext.customDates"
                    :min="teamReviewContext.minDate"
                    :max="teamReviewContext.maxDate"
                    range
                    scrollable
                    type="date"
                    @input="
                      teamReviewContext.menu = false
                      teamReviewContext.onCustomDateSelected()
                    "
                  ></v-date-picker>
                </v-menu>
              </div>
            </v-card>
          </FilterPopOver>
        </div>
      </template>

      <!-- Mobile Tab Contents -->
      <template v-for="tab in teamReviewContext.visibleTabs" v-slot:[tab.key]>
        <!-- Map and Timeline rendered inside simple blocks without complex sidebars on mobile -->
        <div v-if="tab.key === 'map'" :key="tab.key" class="map-container">
          <MapView
            :location-history="teamReviewContext.timelineData"
            :selected-user-id="teamReviewContext.selectedUserId"
            :userLiveLocation="teamReviewContext.timelineData"
            :timelineData="teamReviewContext.timelineData"
            :focusedUserId="teamReviewContext.selectedUserId"
            :apiLoading="teamReviewContext.apiLoading"
          />
        </div>

        <div v-else-if="tab.key === 'timeline'" :key="tab.key" class="pa-2">
          <TimeLineNewVue ref="duplicateTimeLine" />
        </div>

        <!-- Attendance, Roster, Calendar, and Custom components -->
        <component
          v-else
          :is="tab.component"
          :key="tab.key"
          :orgConfig="teamReviewContext.orgConfig"
          :teamData="teamReviewContext.teamData"
          :startOfMonth="teamReviewContext.startOfMonth"
          :endOfMonth="teamReviewContext.endOfMonth"
          :customDates="teamReviewContext.customDates"
          :dateRangeType="teamReviewContext.dateRangeType"
          :roasterDrawer="teamReviewContext.roasterDrawer"
          :search="teamReviewContext.employeeSearch"
          :date-range-types="teamReviewContext.dateRangeTypes"
          :teamReviewContext="teamReviewContext"
        />
      </template>
    </ActitiveTabcomponent>

    <!-- Mobile Pagination -->
    <div class="px-4 py-3 bg-white border-t flex justify-center sticky bottom-0 left-0 right-0 z-10" v-if="teamReviewContext.totalPages > 1 && teamReviewContext.activeTab !== 'map'">
      <v-pagination
        v-model="teamReviewContext.currentPage"
        :length="teamReviewContext.totalPages"
        :total-visible="5"
        :color="$vuetify.theme.currentTheme.primary"
        dense
      ></v-pagination>
    </div>
  </v-main>
</template>

<script>
import FilterPopOver from '@/components/FilterPopOver.vue'
import ActitiveTabcomponent from '@/components/ActitiveTabcomponent.vue'
import MapView from '@/components/Workforce/EmployeeManagement/MapView.vue'
import TimeLineNewVue from '@/components/Workforce/AttendanceManagement/TimeLineNew.vue'
import AttendanceTable from '@/components/Workforce/AttendanceManagement/AttendancePage.vue'
import RoasterTable from '@/components/Workforce/AttendanceManagement/RoasterTable.vue'
import TeamReviewCalendar from '@/components/Workforce/AttendanceManagement/TeamReviewCalendar.vue'

export default {
  name: 'TeamReview_mobile',
  components: {
    FilterPopOver,
    ActitiveTabcomponent,
    MapView,
    TimeLineNewVue,
    AttendanceTable,
    RoasterTable,
    TeamReviewCalendar
  },
  inject: ['teamReviewContext']
}
</script>

<style scoped>
.map-container {
  height: calc(100vh - 110px);
  width: 100%;
}
</style>
